// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "form-1LDSH";
var _4 = "infoMessages-19iw3";
var _5 = "label-y8iU_";
export { _1 as "__esModule", _2 as "mobile", _3 as "form", _4 as "infoMessages", _5 as "label" }
export default { "__esModule": _1, "mobile": _2, "form": _3, "infoMessages": _4, "label": _5 }
